import { useSelector } from 'react-redux';
import { countTextLengthBlocks } from '@src/services/project';
import { MAX_TOTAL_CHARACTERS } from '@src/constants/project';

export const isOverCharacterLimit = (blocks) =>
  countTextLengthBlocks(blocks || {}, 'text') > MAX_TOTAL_CHARACTERS;

const useIsOverCharacterLimit = () =>
  useSelector((s) => isOverCharacterLimit(s.project.multiBlock?.blocks));

export default useIsOverCharacterLimit;
